import React from 'react';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { TOUR_TARGETS } from 'components/UserTour/constants/tourTargets';
import { ADMIN, RETAILER } from 'constants/roles';
import * as route from 'constants/routes';
import i18n from 'i18n';

export const superUserMenuItem = {
  id: 'sa',
  label: i18n.t('menu:superUser'),
  icon: 'fe-shield',
  link: route.SUPER_USER,
  items: [
    {
      id: 'sa.1',
      label: i18n.t('menu:superUserOrders'),
      link: route.SUPER_USER_ORDERS,
    },
    {
      id: 'sa.2',
      label: i18n.t('menu:superUserTiers'),
      link: route.SUPER_USER_TIERS,
    },
    {
      id: 'sa.3',
      label: i18n.t('menu:superUserRegions'),
      link: route.SUPER_USER_REGIONS,
    },
    {
      id: 'sa.4',
      label: i18n.t('menu:superUserAccess'),
      link: route.SUPER_USER_ACCESS,
    },
  ],
};

export const menuItems = [
  {
    id: '0',
    label: i18n.t('menu:dashboard'),
    icon: 'fe-pie-chart',
    link: route.DASHBOARD,
    roles: [ADMIN],
    items: [
      {
        id: '0.1',
        icon: 'fe-grid',
        label: i18n.t('pages:dashboard.overviewTitle'),
        link: route.DASHBOARD,
        roles: [ADMIN],
        end: true,
      },
      {
        id: '0.2',
        icon: 'fe-layout',
        label: i18n.t('pages:dashboard.looksTitle'),
        link: route.DASHBOARD_LOOKS,
        roles: [ADMIN],
      },
      {
        id: '0.3',
        icon: 'fe-package',
        label: i18n.t('pages:dashboard.productsTitle'),
        link: route.DASHBOARD_PRODUCTS,
        roles: [ADMIN],
      },
      {
        id: '0.4',
        icon: 'fe-shopping-cart',
        label: i18n.t('menu:orders'),
        link: route.DASHBOARD_ORDERS,
        roles: [ADMIN],
      },
    ],
  },
  {
    id: '2',
    label: i18n.t('menu:contentManager'),
    icon: 'fe-image',
    link: route.REGION_LOOKS,
    roles: [ADMIN],
    className: TOUR_TARGETS.CONTENT_MANAGER,
    items: [
      {
        id: '2.1',
        icon: 'fe-layout',
        label: i18n.t('menu:adminLooks'),
        link: route.REGION_LOOKS,
        roles: [ADMIN],
        className: TOUR_TARGETS.REGION_LOOKS,
      },
      {
        id: '2.2',
        icon: 'fe-code',
        label: i18n.t('menu:embeddableWidgets'),
        link: route.WIDGETS,
        roles: [ADMIN],
      },
      {
        id: '2.3',
        icon: 'fe-image',
        label: i18n.t('pages:contentManager.banners.tabTitle'),
        link: route.BANNERS,
        roles: [ADMIN],
      },
      {
        id: '2.4',
        icon: 'fe-video',
        label: i18n.t('pages:contentManager.videos.tabTitle'),
        link: route.VIDEOS,
        roles: [ADMIN],
      },
    ],
  },
  {
    id: '4',
    label: i18n.t('menu:products'),
    icon: 'fe-package',
    link: route.PRODUCTS,
    roles: [ADMIN],
    className: TOUR_TARGETS.PRODUCTS,
    items: [
      {
        id: '4.1',
        label: i18n.t('menu:parentProducts'),
        link: route.PARENT_PRODUCTS,
        roles: [ADMIN],
      },
      {
        id: '4.2',
        label: i18n.t('menu:childProducts'),
        link: route.CHILD_PRODUCTS,
        roles: [ADMIN],
      },
      {
        id: '4.3',
        label: i18n.t('menu:colors'),
        link: route.COLORS,
        roles: [ADMIN],
      },
      {
        id: '4.4',
        label: i18n.t('menu:sizes'),
        link: route.SIZES,
        roles: [ADMIN],
      },
      {
        id: '4.5',
        label: i18n.t('menu:categories'),
        link: route.CATEGORIES,
        roles: [ADMIN],
      },
      {
        id: '4.6',
        label: i18n.t('menu:inventories'),
        link: route.INVENTORIES,
        roles: [ADMIN],
      },
    ],
  },
  {
    id: '5',
    label: i18n.t('menu:sellers'),
    icon: 'fe-users',
    link: route.RETAILERS,
    activePaths: [{ path: route.RETAILER, end: false }],
    roles: [ADMIN],
    className: TOUR_TARGETS.RETAILERS,
  },
  {
    id: '6',
    label: i18n.t('menu:store'),
    icon: 'fa-shopping-cart',
    renderIcon: () => (
      <div className="fe">
        <StorefrontIcon />
      </div>
    ),
    link: route.STORE,
    roles: [RETAILER],
  },
  {
    id: '7',
    label: i18n.t('menu:locations'),
    icon: 'fe-map-pin',
    roles: [RETAILER],
    link: route.RETAILER_LOCATIONS,
    items: [
      {
        id: '7.1',
        label: i18n.t('menu:locationGroups'),
        icon: 'fe-layers',
        link: route.RETAILER_LOCATION_GROUPS,
        roles: [RETAILER],
      },
    ],
  },
  {
    id: '8',
    label: i18n.t('menu:locations'),
    icon: 'fe-map-pin',
    roles: [ADMIN],
    link: route.LOCATIONS,
    className: TOUR_TARGETS.LOCATIONS,
    items: [
      {
        id: '8.1',
        label: i18n.t('menu:locationGroups'),
        icon: 'fe-layers',
        link: route.LOCATION_GROUPS,
        roles: [ADMIN],
      },
    ],
  },
  {
    id: '9',
    label: i18n.t('menu:retailerLooks'),
    icon: 'fe-layout',
    link: route.RETAILER_LOOKS,
    roles: [RETAILER],
  },
  {
    id: '10',
    label: i18n.t('menu:favoriteProducts'),
    icon: 'fe-star',
    link: route.FAVORITE_PRODUCTS,
    roles: [RETAILER],
  },
  {
    id: '11',
    label: i18n.t('menu:events'),
    icon: 'fe-calendar',
    link: route.EVENTS,
    roles: [ADMIN],
  },
  {
    id: '12',
    label: i18n.t('menu:events'),
    icon: 'fe-calendar',
    link: route.EVENTS,
    roles: [RETAILER],
  },
  {
    id: '13',
    label: i18n.t('menu:orders'),
    icon: 'fe-shopping-cart',
    link: route.ORDERS,
    roles: [ADMIN],
    className: TOUR_TARGETS.ORDERS,
  },
  {
    id: '18',
    label: i18n.t('menu:retailerSales'),
    icon: 'fe-shopping-cart',
    link: route.RETAILER_SALES,
    roles: [RETAILER],
  },
  {
    id: '14',
    label: i18n.t('menu:howToHub'),
    icon: 'fe-help-circle',
    link: route.HOW_TO_HUB_RETAILER,
    roles: [RETAILER],
  },
  {
    id: '16',
    label: i18n.t('menu:embeddableWidgets'),
    icon: 'fe-code',
    link: route.WIDGETS,
    roles: [RETAILER],
  },
];
